import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ New Footer Import
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Tip!

const HelpPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>Need Help?</h1>

        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />
        
        <p>If something’s not working right, don’t worry — you’re not alone. dAIsy is here to help, and so are we.</p>

        <ul>
          <li>🔒 Trouble logging in? Double-check your email and password.</li>
          <li>🧠 Want to update your memories? That’s coming soon!</li>
          <li>💬 Not getting the response you expected? Try rephrasing or ask dAIsy directly.</li>
          <li>📩 Still stuck? Email us at <strong>support@daisypal.com</strong></li>
        </ul>

        {/* Footer */}
        <FooterLinks /> {/* ✅ Clean footer here */}
      </div>
    </div>
  );
};

export default HelpPage;
